module.exports = __webpack_public_path__ + "assets/img/avatar-light.2f05c853.png";